// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as HomeRouteRouteImport } from './routes/_home/route'
import { Route as PrinterResumeIdRouteImport } from './routes/printer/$resumeId'
import { Route as UsernameSlugRouteImport } from './routes/$username/$slug'
import { Route as BuilderResumeIdRouteRouteImport } from './routes/builder/$resumeId/route'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AuthVerify2faBackupRouteImport } from './routes/auth/verify-2fa-backup'
import { Route as AuthVerify2faRouteImport } from './routes/auth/verify-2fa'
import { Route as AuthResumePasswordRouteImport } from './routes/auth/resume-password'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as HomeIndexRouteImport } from './routes/_home/index'
import { Route as BuilderResumeIdIndexRouteImport } from './routes/builder/$resumeId/index'
import { Route as DashboardResumesIndexRouteImport } from './routes/dashboard/resumes/index'
import { Route as DashboardJobSearchIndexRouteImport } from './routes/dashboard/job-search/index'
import { Route as DashboardSettingsProfileRouteImport } from './routes/dashboard/settings/profile'
import { Route as DashboardSettingsPreferencesRouteImport } from './routes/dashboard/settings/preferences'
import { Route as DashboardSettingsJobSearchRouteImport } from './routes/dashboard/settings/job-search'
import { Route as DashboardSettingsDangerZoneRouteImport } from './routes/dashboard/settings/danger-zone'
import { Route as DashboardSettingsApiKeysRouteImport } from './routes/dashboard/settings/api-keys'
import { Route as DashboardSettingsAiRouteImport } from './routes/dashboard/settings/ai'
import { Route as DashboardSettingsIntegrationsRouteRouteImport } from './routes/dashboard/settings/integrations/route'
import { Route as DashboardSettingsAuthenticationIndexRouteImport } from './routes/dashboard/settings/authentication/index'

const DashboardRouteRoute = DashboardRouteRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const AuthRouteRoute = AuthRouteRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const HomeRouteRoute = HomeRouteRouteImport.update({
            id: '/_home',getParentRoute: () => rootRouteImport
          })
const PrinterResumeIdRoute = PrinterResumeIdRouteImport.update({
            id: '/printer/$resumeId',path: '/printer/$resumeId',getParentRoute: () => rootRouteImport
          })
const UsernameSlugRoute = UsernameSlugRouteImport.update({
            id: '/$username/$slug',path: '/$username/$slug',getParentRoute: () => rootRouteImport
          })
const BuilderResumeIdRouteRoute = BuilderResumeIdRouteRouteImport.update({
            id: '/builder/$resumeId',path: '/builder/$resumeId',getParentRoute: () => rootRouteImport
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRouteRoute
          })
const AuthIndexRoute = AuthIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthRouteRoute
          })
const AuthVerify2faBackupRoute = AuthVerify2faBackupRouteImport.update({
            id: '/verify-2fa-backup',path: '/verify-2fa-backup',getParentRoute: () => AuthRouteRoute
          })
const AuthVerify2faRoute = AuthVerify2faRouteImport.update({
            id: '/verify-2fa',path: '/verify-2fa',getParentRoute: () => AuthRouteRoute
          })
const AuthResumePasswordRoute = AuthResumePasswordRouteImport.update({
            id: '/resume-password',path: '/resume-password',getParentRoute: () => AuthRouteRoute
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRouteRoute
          })
const AuthRegisterRoute = AuthRegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => AuthRouteRoute
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AuthRouteRoute
          })
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => AuthRouteRoute
          })
const HomeIndexRoute = HomeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HomeRouteRoute
          })
const BuilderResumeIdIndexRoute = BuilderResumeIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BuilderResumeIdRouteRoute
          })
const DashboardResumesIndexRoute = DashboardResumesIndexRouteImport.update({
            id: '/resumes/',path: '/resumes/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardJobSearchIndexRoute = DashboardJobSearchIndexRouteImport.update({
            id: '/job-search/',path: '/job-search/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsProfileRoute = DashboardSettingsProfileRouteImport.update({
            id: '/settings/profile',path: '/settings/profile',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsPreferencesRoute = DashboardSettingsPreferencesRouteImport.update({
            id: '/settings/preferences',path: '/settings/preferences',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsJobSearchRoute = DashboardSettingsJobSearchRouteImport.update({
            id: '/settings/job-search',path: '/settings/job-search',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsDangerZoneRoute = DashboardSettingsDangerZoneRouteImport.update({
            id: '/settings/danger-zone',path: '/settings/danger-zone',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsApiKeysRoute = DashboardSettingsApiKeysRouteImport.update({
            id: '/settings/api-keys',path: '/settings/api-keys',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsAiRoute = DashboardSettingsAiRouteImport.update({
            id: '/settings/ai',path: '/settings/ai',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsIntegrationsRouteRoute = DashboardSettingsIntegrationsRouteRouteImport.update({
            id: '/settings/integrations',path: '/settings/integrations',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsAuthenticationIndexRoute = DashboardSettingsAuthenticationIndexRouteImport.update({
            id: '/settings/authentication/',path: '/settings/authentication/',getParentRoute: () => DashboardRouteRoute
          })





const HomeRouteRouteChildren = {
  HomeIndexRoute: HomeIndexRoute
}

const HomeRouteRouteWithChildren = HomeRouteRoute._addFileChildren(HomeRouteRouteChildren)




const AuthRouteRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,AuthLoginRoute: AuthLoginRoute,AuthRegisterRoute: AuthRegisterRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthResumePasswordRoute: AuthResumePasswordRoute,AuthVerify2faRoute: AuthVerify2faRoute,AuthVerify2faBackupRoute: AuthVerify2faBackupRoute,AuthIndexRoute: AuthIndexRoute
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(AuthRouteRouteChildren)




const DashboardRouteRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,DashboardSettingsIntegrationsRouteRoute: DashboardSettingsIntegrationsRouteRoute,DashboardSettingsAiRoute: DashboardSettingsAiRoute,DashboardSettingsApiKeysRoute: DashboardSettingsApiKeysRoute,DashboardSettingsDangerZoneRoute: DashboardSettingsDangerZoneRoute,DashboardSettingsJobSearchRoute: DashboardSettingsJobSearchRoute,DashboardSettingsPreferencesRoute: DashboardSettingsPreferencesRoute,DashboardSettingsProfileRoute: DashboardSettingsProfileRoute,DashboardJobSearchIndexRoute: DashboardJobSearchIndexRoute,DashboardResumesIndexRoute: DashboardResumesIndexRoute,DashboardSettingsAuthenticationIndexRoute: DashboardSettingsAuthenticationIndexRoute
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(DashboardRouteRouteChildren)




const BuilderResumeIdRouteRouteChildren = {
  BuilderResumeIdIndexRoute: BuilderResumeIdIndexRoute
}

const BuilderResumeIdRouteRouteWithChildren = BuilderResumeIdRouteRoute._addFileChildren(BuilderResumeIdRouteRouteChildren)

const rootRouteChildren = {
  HomeRouteRoute: HomeRouteRouteWithChildren,AuthRouteRoute: AuthRouteRouteWithChildren,DashboardRouteRoute: DashboardRouteRouteWithChildren,BuilderResumeIdRouteRoute: BuilderResumeIdRouteRouteWithChildren,UsernameSlugRoute: UsernameSlugRoute,PrinterResumeIdRoute: PrinterResumeIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)